import { EmblaOptionsType } from 'embla-carousel'
import useEmblaCarousel from 'embla-carousel-react'
import { ReactNode, forwardRef, useImperativeHandle } from 'preact/compat'
import { DotButton, useDotButton } from './CarouselDotButton'

type PropType = {
  slides?: number[]
  options?: EmblaOptionsType;
  children: ReactNode;
  dotColor?: string;
}

export type CarouselRef = {
  scrollNext: () => void;
  scrollPrev: () => void;
  scrollTo: (index: number) => void;
}

export const Carousel = forwardRef<CarouselRef, PropType>((props, ref) => {
  const { children, options, dotColor } = props
  const [carouselRef, emblaApi] = useEmblaCarousel(options)
  
  useImperativeHandle(ref, () => ({
    scrollNext: () => emblaApi?.scrollNext(),
    scrollPrev: () => emblaApi?.scrollPrev(),
    scrollTo: (index: number) => emblaApi?.scrollTo(index)
  }));

  const { selectedIndex, scrollSnaps, onDotButtonClick } =
    useDotButton(emblaApi)


  return (
    <section className="embla max-w-[48rem] h-full relative z-0">
      <div className='embla__viewport overflow-hidden h-full' ref={carouselRef}>
        <div className="embla__container h-full flex touch-pan-y touch-pinch-zoom ml-[calc(var(--slide-spacing)*-1)]">
          {children}
        </div>
      </div>

      {Array.from(children).length > 1 && 
        <div className="embla__dots flex gap-2 absolute z-10 bottom-[30px] w-full justify-center ">
          {scrollSnaps.map((_, index) => (
            <DotButton
              key={index}
              onClick={() => onDotButtonClick(index)}
              className={
                'embla__dot rounded-full w-2 h-2'
              }
              style={{
                backgroundColor: dotColor || 'black',
                opacity: index === selectedIndex ? 1 : 0.3
              }}
            >
            </DotButton>
          ))}
      </div>}
    </section>
  )
})